import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 43 58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "4",
      d: "M32 52c0 .448-.445 1.44-2.527 2.44C27.536 55.37 24.72 56 21.5 56s-6.036-.63-7.973-1.56C11.445 53.44 11 52.448 11 52s.445-1.44 2.527-2.44C15.464 48.63 18.28 48 21.5 48s6.036.63 7.973 1.56C31.555 50.56 32 51.552 32 52Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "#fff",
      "stroke-width": "2",
      d: "m22.82 51.735 1.807-1.467c2.864-3 5.574-6.145 8.12-9.423 2.196-2.842 4.452-6.073 6.178-9.291C40.6 28.43 42 24.91 42 21.6 42 9.92 32.79 1 21.5 1S1 9.921 1 21.6c0 3.31 1.4 6.83 3.075 9.956 1.726 3.214 3.985 6.447 6.176 9.287a122 122 0 0 0 8.594 9.918c.536.544.915.8 1.334.974a3.43 3.43 0 0 0 2.64 0Zm3.142-25.643A6.3 6.3 0 0 1 21.5 27.95a6.3 6.3 0 0 1-4.462-1.858 6.37 6.37 0 0 1-1.85-4.492c0-1.686.666-3.302 1.85-4.492A6.3 6.3 0 0 1 21.5 15.25c1.672 0 3.278.668 4.462 1.858a6.37 6.37 0 0 1 1.85 4.492 6.37 6.37 0 0 1-1.85 4.492Z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "21.5",
      cy: "21.5",
      r: "14.5",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render: render }